/* 🤖 this file was generated by script */
export const wsolidiconShare07 = {
  name: 'share_07',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M14 5a4 4 0 1 1 1.16 2.81l-5.31 3.1a4 4 0 0 1 0 2.18l5.31 3.1A3.99 3.99 0 0 1 22 19a4 4 0 1 1-7.85-1.1l-5.3-3.09A3.99 3.99 0 0 1 2 12a4 4 0 0 1 6.84-2.81l5.31-3.1A4 4 0 0 1 14 5"/></svg>`,
  iconStyle: 'solid',
};
